import {
	isBlank
}
from 'voUtils/tools.js';

import {
	favCount, onFavUpdate
}
from 'voUtils/FavStore.js';

export default {

	data: {
		name: undefined,
		showNavbar: false
	},
	computed: {
		mailto: function () {
			return `mailto:${this.emailAddress}`;
		},
		emailAddress: function () {
			return (VOFFICE.contactEmail || ['info', 'test.de']).join('@');
		}

	},

	mounted: function () {
		onFavUpdate(() => {
			this.$forceUpdate();
		});
		$("#mob-nav-icon").click(function () {
			$("body").toggleClass("menushow");
		});
	},

	methods: {

		navbarToggle: function () {

			$('.main-menu').slideToggle();
			$('.navbar-v1').removeClass('open-by-mob');

		},

		favCount: favCount,
		goSearch: function () {
			if (isBlank(this.name)) {
				window.location.href = 's';
			} else {
				window.location.href = 's#?name=' + encodeURIComponent(this.name);
			}
		}



	}
};

$(function () {
	var header = $(".stickyheader");
	$(window).scroll(function () {
		var scroll = $(window).scrollTop();

		if (scroll >= 10) {
			header.removeClass('stickyheader').addClass("darkHeader");
		} else {
			header.removeClass("darkHeader").addClass('stickyheader');
		}
	});
});